// React
import React from 'react';

// Styles
import '../styles/Game.css';

// Components
import MainButton from '../components/MainButton';
import MissionHeader from '../components/MissionHeader';
import GameCard from '../components/GameCard';
import Timer from '../components/Timer';
import PauseTimerPopUp from '../components/PauseTimerPopUp';
import AddCardPopUp from '../components/AddCardPopUp';
import IndiceCardPopUp from '../components/IndiceCardPopUp';
import PageTransition from '../components/PageTransition';

// Contexts
import { useTimer } from '../contextes/useTimer';
import { useNavigate } from 'react-router';

// Fonctions
import { handleAddPenalty } from '../Fonctions';

// Page de jeu principale
const Game = () => {
    const [isPaused, setIsPaused] = React.useState(false);
    const [isAddCardOpen, setIsAddCardOpen] = React.useState(false);
    const [isPenaltyAdded, setIsPenaltyAdded] = React.useState(false);
    const [showIndiceCardPopup, setShowIndiceCardPopup] = React.useState(false);
    const { removeTime } = useTimer();
    const navigate = useNavigate();

    return (
        <PageTransition>
            <div className='game-container'>
                <div className='game-gradient'></div>

                {/* Affiche les pop-ups selon l'état */}

                {/* Si le jeu est en pause on affiche la popup PauseTimer */}
                {isPaused && <PauseTimerPopUp setIsPaused={setIsPaused} />}

                {/* Si on veut chercher une carte on affiche la popup AddCard */}
                {isAddCardOpen && <AddCardPopUp setIsAddCardOpen={setIsAddCardOpen} />}

                {/* Si on veut voir une indice on affiche la popup IndiceCard */}
                {showIndiceCardPopup && (
                    <IndiceCardPopUp setShowIndiceCardPopup={setShowIndiceCardPopup} />
                )}
                <MissionHeader
                    showBackButton={false}
                    showSettingsButton={false}
                    showCloseButton={true}
                    logoVariant='alternate'
                    closeFunction={() => navigate('/')}
                    showTimer={false}
                    soundButtonVariant='tertiary'
                />
                <Timer
                    setIsPaused={setIsPaused}
                    isPenaltyAdded={isPenaltyAdded}
                />
                <div className='game-cards-container'>
                    <GameCard
                        title='Pénalité'
                        subtitle='Ajouter une'
                        image='./images/penalty-image.png'
                        backgroundColor='red'
                        width='7.81rem'
                        onClick={() => handleAddPenalty(removeTime, setIsPenaltyAdded)}
                    />
                    <GameCard
                        title='Machine'
                        subtitle='Ajouter une carte'
                        image='./images/card-image.png'
                        backgroundColor='blue'
                        width='4.06rem'
                        onClick={() => setIsAddCardOpen(true)}
                    />
                </div>
                <MainButton
                    text='Indice'
                    backgroundColor='primary'
                    hasAnIcon={true}
                    iconSrc='./images/idea-icon.png'
                    onClick={() => setShowIndiceCardPopup(true)}
                />
                <div className='game-gradient-2'></div>
            </div>
        </PageTransition>
    );
};

export default Game;
